import { CourseRequirementType, ICourse } from '@/types/courses';
import { EColorVariablesV2 } from '@/types/theme-packs.types';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import Modal from '@ui/modal/modal';
import Text from '@ui/text/text/text';

type Props = {
  requirementToDelete: string | null;
  setRequirementToDelete: (uuid: string | null) => void;
  course: ICourse | null;
  deleteRequirement: () => void;
};
export default function CourseDeleteRequirementModal({
  requirementToDelete,
  setRequirementToDelete,
  course,
  deleteRequirement,
}: Props) {
  return (
    <Modal
      open={!!requirementToDelete}
      customSize={{
        width: '600px',
        height: 'auto',
        maxHeight: '300px',
        minHeight: '200px',
        maxWidth: 'calc(100vw - 80px)',
      }}
      onRequestClose={() => setRequirementToDelete(null)}
      renderHeaderContent={() => {
        return (
          <Container background="var(--gray-900)" className="padding-16 radius-10">
            <Text clamp={2} whiteSpace="wrap" tag="h3" color="var(--gray-100)" className="H3 margin-b-8">
              Delete requirement
            </Text>
          </Container>
        );
      }}
      renderFooterContent={() => {
        return (
          <Container
            background="var(--gray-900)"
            borderRadius="0 0 12px 12px"
            className="flex fd-row jc-flex-end ai-center padding-16"
          >
            <button className="L1 padding-v-8 padding-h-16 margin-r-8" onClick={() => setRequirementToDelete(null)}>
              Cancel
            </button>
            <Button
              width="105px"
              className="padding-v-8 padding-h-16"
              onClick={deleteRequirement}
              backgroundColor={getThemeColorCSSVariable()}
            >
              <Text
                color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}
                className="L1"
              >
                Delete
              </Text>
            </Button>
          </Container>
        );
      }}
    >
      <Container background="var(--gray-900)" className="padding-16 overflow-auto" height="100%">
        <Text tag="p" color="var(--gray-300)" className="P2">
          Are you sure you want to delete this&nbsp;
          <b>
            {course?.requirements?.find((requirement) => requirement.uuid === requirementToDelete)?.type ===
            CourseRequirementType.watched_minute
              ? 'Watchtime'
              : 'Pulse check'}
          </b>{' '}
          requirement?
        </Text>
      </Container>
    </Modal>
  );
}
